import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import InputField from '../components/forms/InputField';
import {
    CForm,
    CFormInput,
    CInputGroup,
    CInputGroupText,
    CRow,
    CCol,
    CAlert,
    CButton,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'
import { useFormik } from 'formik'
import * as Yup from 'yup';
import CIcon from '@coreui/icons-react'
import Swal from 'sweetalert2'
import { cilLockLocked, cilLockUnlocked, cilUser } from '@coreui/icons'
import { requestOTP, sendLogin, clearMessage } from '../actions/auth.actions';
import ReCAPTCHA from "react-google-recaptcha";
import logo from "../assets/images/logo_jabes_color.png"

const Login = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(true);
    const [visible, setVisible] = useState(false);
    const auth = useSelector((state) => state.auth);

    const [loadRecaptcha, setLoadRecaptcha] = useState(false);

    useEffect(() => {
        setLoadRecaptcha(true);
    }, []);

    useEffect(() => {
        Swal.close();

        if ((auth.status == 'request-otp') || (auth.status == 'not-authenticated' && auth.message == 'Código de seguridad inválido')) {
            setVisible(true);
        }
    }, [auth]);

    const LoginValidationSchema = Yup.object().shape({
        usuario: Yup.string().required('Por favor ingrese un usuario válido'),
        clave: Yup.string().required('Por favor ingrese un password válido').min(4, 'Mínimo 4 caracteres').max(15, 'Máximo 15 catacteres'),
        recaptcha: (!window.isMobileApp()) ? Yup.string().required('Campo requerido') : Yup.string()
    });

    const formValues = {
        usuario: '',
        clave: '',
        recaptcha: '',
        otp: ''
    }

    const formik = useFormik({
        validationSchema: LoginValidationSchema,
        initialValues: formValues,
        onSubmit: async values => {
            Swal.fire({
                title: 'Por favor, espere.',
                html: 'Solicitando código de seguridad',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });
            dispatch(requestOTP(values.usuario, values.clave));
        }
    });

    const OTPValidationSchema = Yup.object().shape({
        otp: Yup.string().required('Por favor ingrese un código de seguridad válido').length(4, 'El código de seguridad debe ser de 4 dígitos')
    });

    const formOTP = {
        otp: ''
    }

    const formikOTP = useFormik({
        validationSchema: OTPValidationSchema,
        initialValues: formOTP,
        onSubmit: async values => {
            setVisible(false);
            dispatch(sendLogin(formik.values.usuario, formik.values.clave, values.otp));
        }
    });

    const irRecovery = () => {
        dispatch(clearMessage());
        navigate('/recovery');
    }

    const show = () => {
        var p = window.document.getElementById('clave');
        p.setAttribute('type', 'text');
    }

    const hide = () => {
        var p = window.document.getElementById('clave');
        p.setAttribute('type', 'password');
    }

    const showPass = () => {
        if (showPassword) {
            setShowPassword(false);
            show();
        } else {
            setShowPassword(true);
            hide();
        }
    }

    const onChange = async (value) => {
        formik.handleChange('recaptcha');

        if (value === null) {
            formik.setFieldValue('recaptcha', '');
        } else {
            formik.setFieldValue('recaptcha', value);
        }
    }

    const openLink = (url) => {
        if(window.isMobileApp()) {
            window.open = window.cordova.InAppBrowser.open;
        }
        window.open(url, "_blank", "clearsessioncache=yes");
    }

    return (
        <div className="container-fluid ps-md-0 login-form" >
            <div className="row g-0">
                <div className="d-none d-md-flex col-md-7 col-lg-7 col-xl-9 col-xxl-9 bg-login-image"></div>
                <div className="col-md-5 col-lg-5 col-xl-3 col-xxl-3">
                    <div className="login d-flex align-items-center py-5">
                        <div className="container">
                            <div className="row mb-5">
                                <div className="col-md-8 col-lg-6 mx-auto text-center">
                                    <img src={logo} className="login-logo" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9 col-lg-8 mx-auto">
                                    <h3 className="login-heading mb-4">Acceso al sistema</h3>
                                    <p className="text-medium-emphasis">Ingrese su usuario y contraseña</p>
                                    {auth.message && (
                                        <CAlert color="danger">
                                            {auth.message}
                                        </CAlert>
                                    )}
                                    <CForm onSubmit={formik.handleSubmit}>
                                        <CInputGroup className="mb-3">
                                            <CInputGroupText>
                                                <CIcon icon={cilUser} />
                                            </CInputGroupText>
                                            <CFormInput
                                                id="usuario"
                                                placeholder="Username"
                                                className={!formik.touched.usuario ? '' : formik.errors.usuario ? 'is-invalid' : ''}
                                                onChange={formik.handleChange}
                                                value={formik.values.usuario}
                                            />
                                            {formik.errors.usuario && <div className="invalid-feedback">{formik.errors.usuario}</div>}
                                        </CInputGroup>
                                        <CInputGroup className="mb-4">
                                            <CInputGroupText>
                                                <CIcon icon={cilLockLocked} />
                                            </CInputGroupText>
                                            <CFormInput
                                                id="clave"
                                                type="password"
                                                placeholder="Password"
                                                className={!formik.touched.clave ? '' : formik.errors.clave ? 'is-invalid' : ''}
                                                onChange={formik.handleChange}
                                                value={formik.values.clave}
                                            />
                                            <CInputGroupText>
                                                <i className="fa fa-eye eye" aria-hidden="true" type="button" onClick={showPass}></i>
                                            </CInputGroupText>
                                            {formik.errors.clave && <div className="invalid-feedback">{formik.errors.clave}</div>}
                                        </CInputGroup>
                                        <CRow className='mb-4'>
                                            {loadRecaptcha && !window.isMobileApp() && (
                                                <ReCAPTCHA
                                                    id="recaptcha"
                                                    sitekey="6LeIWkEsAAAAAPHRYMsdlok88QOrbg1jZSgnfSZ0"
                                                    onChange={onChange}
                                                    className={!formik.touched.recaptcha ? '' : formik.errors.recaptcha ? 'is-invalid' : ''}
                                                />
                                            )}
                                            {formik.errors.recaptcha && <div className="invalid-feedback">{formik.errors.recaptcha}</div>}
                                        </CRow>
                                        <div className="d-grid mt-5">
                                            <button className="btn btn-lg btn-primary btn-login text-uppercase fw-bold mb-2" type="submit">
                                                Login
                                            </button>
                                            <div className="text-center">
                                                <a className="small" role="button" onClick={irRecovery}>¿Olvidó su contraseña?</a>
                                            </div>

                                        </div>
                                        <div className="d-grid mt-5">
                                            <div className="text-center">
                                                <a className="small" role="button" onClick={() => openLink('https://jabesdinased.net/politica-privacidad')}>Política de privacidad</a>
                                            </div>
                                        </div>
                                    </CForm>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CModal alignment="center" visible={visible} backdrop={'static'} onClose={() => setVisible(false)}>
                <CModalHeader onClose={() => setVisible(false)}>
                    <CModalTitle>
                        <CIcon icon={cilLockLocked} size="lg" className='me-2' />
                        Código de seguridad
                    </CModalTitle>
                </CModalHeader>
                <CForm onSubmit={formikOTP.handleSubmit}>
                    <CModalBody>
                        {auth.message && (
                            <CAlert color="success">
                                {auth.message}
                            </CAlert>
                        )}
                        <CRow>
                            <CCol>
                                <div className="mb-3">
                                    <InputField
                                        formik={formikOTP}
                                        nombre="otp"
                                        etiqueta="Código de seguridad"
                                        placeHolder="Ingrese el código de seguridad"
                                    />
                                </div>
                            </CCol>
                        </CRow>
                    </CModalBody>
                    <CModalFooter>
                        <CButton type="submit" color="info">
                            <CIcon icon={cilLockUnlocked} size="lg" className='me-2' />
                            Validar código
                        </CButton>
                    </CModalFooter>
                </CForm>
            </CModal>
        </div>
    )
}

export default Login
